// extracted by mini-css-extract-plugin
export default {"didYouKnow":"DidYouKnow_didYouKnow__8MidO"};